module.exports = __webpack_public_path__ + "img/signout.2432cc71.svg";